import { format } from 'date-fns';
import TableCellStatus from '../../components/table-cell-status/table-cell-status.component';
import { displayCellValue, displayCellValueNumberToTwoDecimal } from '../../utils/column-values.util';
import { useMediaQuery } from 'react-responsive';

export const PURCHASE_REPORT_BY_PAYMENT_INFO = {
    reportTitle: "Purchasing Reports",
    path: "/purchasereports",
    subPath: "/purchasebypayment",
    listPage: "/purchase-reports",
    pagePath:"purchase-orders",
    hasDateRange: true,
    hasChart: true,
    tableHasGrandTotal: true,
    hasPaymentStatusFilter: true,
    hasLocationFilter: false,
    hasSearch: true
}

export const PURCHASE_REPORT_BY_PAYMENT_COLUMN_TEMPLATE = [
    {
        Header: "PO Number",
        accessor: "purchaseOrderNumber",
        Footer: 'Grand Total'
    },
    {
        Header: "Payment Status",
        accessor: "paymentStatus",
        Cell: ({ value }) => {
            const isMobileView = useMediaQuery({ maxWidth: 991 });
            const isRightAligned = true;

            if (!value) {
                return displayCellValue(value);
            }

            return (
                <div className={isMobileView && isRightAligned ?
                    'report-table__body__row__cell--right-aligned-mobile-cell' : ''}>
                    <TableCellStatus
                        value={value}
                    />
                </div>
            )
        }
    },
    {
        Header: "Supplier",
        accessor: "supplierName",
        Cell: ({ value }) => {
            return displayCellValue(value);
        }
    },
    {
        Header: "Total Purchase (ETB)",
        accessor: "totalPurchase",
        Cell: ({ value }) => {
            const isMobileView = useMediaQuery({ maxWidth: 991 });

            if (isMobileView) {
                return `Total Purchase: ${value ? displayCellValueNumberToTwoDecimal(value) : 0} ETB`;
            }


            return displayCellValueNumberToTwoDecimal(value);
        },
        Footer: 'grandTotalPurchase'
    },
    {
        Header: "Credit (ETB)",
        accessor: "credit",
        Cell: ({ value }) => {
            const isMobileView = useMediaQuery({ maxWidth: 991 });

            if (isMobileView) {
                return `Credit: ${value ? displayCellValueNumberToTwoDecimal(value) : 0} ETB`;
            }

            return displayCellValueNumberToTwoDecimal(value);
        },
        Footer: 'totalCredit'
    },
    {
        Header: "Due Date",
        accessor: "dueDate",
        Cell: ({ value }) => {
            const isMobileView = useMediaQuery({ maxWidth: 991 });

            if (isMobileView) {
                return null;
            }

            return displayCellValue(value);
        }
    },

]
